
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/timeline/following_articles",
      function () {
        return require("private-next-pages/timeline/following_articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/timeline/following_articles"])
      });
    }
  